import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { Amenity } from '../../models/amenity.model';
import { UtilService } from '../../services/util.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Timetable } from '../../models/timetable.model';
import { TimetableService } from '../../services/timetable.service';

@Component({
  selector: 'app-timetable-modal',
  templateUrl: './timetable-modal.component.html',
  styleUrl: './timetable-modal.component.scss'
})
export class TimetableModalComponent {

  @Input() neighborhoodId: string = '';
  @Input() amenity?: Amenity;

  public timetables: Timetable[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private changeDetectorRef: ChangeDetectorRef,
    private timetableService: TimetableService,
    public utilService: UtilService
  ) {}

  ngOnInit(): void {

    this.timetables = [
      ...this.amenity!.timetables
    ];

  }

  async getData() {

    console.log('getData de timetables');
    

    this.timetables = await this.timetableService.getAll(
      this.amenity!
    );

    this.changeDetectorRef.detectChanges();

    console.log('timetables', this.timetables);
    
  }

}
